import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import CountUp from "react-countup";
import { getEventLogs, getEventLogsNew } from "store/eventLog/thunk";
import countryApi from "api/countryApi";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownCountries from "components/Common/DropdownCountries";
import DropdownOption from "components/Common/DropdownOption";
import DropdownPlatform from "components/Common/DropdownPlatform";
import ModalPreview from "components/Common/ModalPreview";
import {
  APP_TYPE_OPTIONS,
  BAR_DETAIL_SCREEN_CONST,
  BAR_MANAGEMENT_SCREEN_CONST,
  BAR_REVIEW_SCREEN_CONST,
  BAR_SCREEN_CONST,
  CHAT_SCREEN_CONST,
  COLOR_USER_TYPE_LOG,
  LIST_OPTION_MENU,
  LIST_OPTION_OS,
  LIST_OPTION_PLATFORM,
  LIST_OPTION_SOURCE_APP,
  LIST_USER_LOG_TYPE_OPTION,
  MY_PROFILE_SCREEN_CONST,
  NEWS_SCREEN_CONST,
  NOTIFICATION_SCREEN_CONST,
  OTHER_PROFILE_SCREEN_CONST,
  SCAN_QR_SCREEN,
  SCREEN_CONST,
  SETTING_SCREEN_CONST,
  USER_TYPE_LOG_OPTION,
  WINK_COMMENT_SCREEN_CONST,
  WINK_DETAIL_SCREEN_CONST,
  WINK_SCREEN_CONST,
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC, getOptionImage, getPlatFormImage } from "helpers/format";
import { capitalizeFirstLetter } from "utils";
import avatar1 from "../../../assets/images/users/ic_defaul_avatar2.png";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import countries from "helpers/countries";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import DropdownOptionImage from "components/Common/DropdownOptionImage";
import CopyWrapper from "components/Common/CopyWrapper";
import IPHONE_MODELS from "helpers/iphone_models";
import DropdownOptionMulti from "components/Common/DropdownOptionMulti";

interface Option {
  label: string;
  value: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const EventLogNew = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    // "sort[createdAt]": withDefault(StringParam, `desc`),
    // order_by: withDefault(StringParam, `DESC`),
    user_nickname: withDefault(StringParam, ""),
    user_email: withDefault(StringParam, ""),
    address: withDefault(StringParam, ""),
    //breadcrumb: withDefault(StringParam, ""),
    device_model: withDefault(StringParam, ""),
    udid_2: withDefault(StringParam, ""),
    bar_id: withDefault(StringParam, ""),
    wink_id: withDefault(StringParam, ""),
    chat_id: withDefault(StringParam, ""),

    ip_address: withDefault(StringParam, ""),
    user_provider: withDefault(StringParam, ""),
    device_os: withDefault(StringParam, ""),
    app_name: withDefault(StringParam, ""),
    menu: withDefault(StringParam, ""),
    screen_codes: withDefault(StringParam, ""),
    action_code: withDefault(StringParam, ""),

    country_code: withDefault(StringParam, ""),
    is_active: withDefault(StringParam, ""),
    user_type: withDefault(StringParam, ""),
    start_date: withDefault(
      StringParam,
      formatDateStringToUTC(
        moment(new Date()).startOf("day").format("Y-MM-DD HH:mm:ss")
      )
    ),
    end_date: withDefault(
      StringParam,
      formatDateStringToUTC(
        moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss")
      )
    ),
    type: withDefault(StringParam, ""),
  });

  const LIST_SOURCE_APP_LANG =
    LIST_OPTION_SOURCE_APP?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const LIST_MENU_LANG =
    LIST_OPTION_MENU?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [user_nicknameSearch, setNicknameSearch] = useState<string>(
    query?.user_nickname || ""
  );
  const [user_emailSearch, setuser_emailSearch] = useState<string>(
    query?.user_email || ""
  );
  const [addressSearch, setAddressSearch] = useState<string>(
    query?.address || ""
  );

  const [IPSearch, setIPSearch] = useState<string>(query?.ip_address || "");
  const [deviceModelSearch, setDeviceModelSearch] = useState<string>(
    query?.device_model || ""
  );
  const [uuidSearch, setUUIDSearch] = useState<string>(query?.udid_2 || "");
  const [barIdSearch, setBarIdSearch] = useState<string>(query?.bar_id || "");
  const [winkIdSearch, setWinkIdSearch] = useState<string>(query?.wink_id || "");
  const [chatIdSearch, setChatIdSearch] = useState<string>(query?.chat_id || "");

  const [platFormSearch, setPlatFormSearch] = useState<Option | null>(
    LIST_OPTION_PLATFORM?.filter(
      (item) => String(item?.value) === String(query?.user_provider)
    )[0]
  );
  const [oSSearch, setOSSearch] = useState<any | null>(
    LIST_OPTION_OS?.filter(
      (item) => String(item?.value) === String(query?.device_os)
    )[0]?.value || ""
  );

  const [isGuestSearch, setIsGuestSearch] = useState<any>(
    USER_TYPE_LOG_OPTION?.find((item) => item?.value === query?.user_type)
      ?.value ?? ""
  );
  const [typeSearch, setTypeSearch] = useState<Option | any>(
    LIST_USER_LOG_TYPE_OPTION?.find((item) => item?.value === query?.type)
      ?.value ?? ""
  );

  const [sourceAppSearch, setSourceAppSearch] = useState<any>(
    LIST_SOURCE_APP_LANG?.find((item) => item?.value === query?.app_name)
      ?.value || ""
  );

  const [menuSearch, setMenuSearch] = useState<Option | null>(
    LIST_MENU_LANG?.filter(
      (item) => String(item?.value) === String(query?.menu)
    )[0]
  );

  const [screenCodeSearch, setScreenCodeSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });

  const [actionCodeSearch, setaction_codeSearch] = useState<any>({});

  const [dateSearch, setDateSearch] = useState<any[]>([
    moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
    moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
  ]);
  const [start_date, end_date] = dateSearch;

  const [linkImage, setLinkImage] = useState<string>("");
  const [countrySearch, setCountrySearch] = useState<any | null>(null);
  const [listCountry, setListCountry] = useState<any>([]);
  const [isMultiScreen, setIsMultiScreen] = useState<boolean>(false);

  const selectLayoutState = (state: any) => state.EventLogNew;
  const EventLogProperties = createSelector(selectLayoutState, (state) => ({
    eventLogs: state.eventLogs,
    isEventLogLoading: state.isEventLogLoading,
    isEventLogSuccess: state.isEventLogSuccess,

    error: state.error,
  }));

  // Inside your component
  const { eventLogs, isEventLogLoading } = useSelector(EventLogProperties);

  function loadTableData() {
    dispatch(getEventLogsNew(query));
  }

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    let screenCode = '';
    if (screenCodeSearch instanceof Array && screenCodeSearch?.length > 0) {
      screenCode = screenCodeSearch?.map((item: any) => (item?.value)).join(",")
    } else if(screenCodeSearch?.value) {
      screenCode = screenCodeSearch?.value
    }

    setQuery({
      ...query,
      user_nickname: user_nicknameSearch.trim() || "",
      user_email: user_emailSearch.trim() || "",
      address: addressSearch.trim() || "",
      //breadcrumb: breadcrumbSearch.trim() || "",
      ip_address: IPSearch.trim() || "",
      device_model: deviceModelSearch.trim() || "",
      udid_2: uuidSearch || "",
      bar_id: barIdSearch || "",
      wink_id: winkIdSearch || "",
      chat_id: chatIdSearch || "",

      user_type: isGuestSearch,
      country_code: countrySearch?.value || "",
      user_provider: platFormSearch?.value || "",
      device_os: oSSearch || "",
      app_name: sourceAppSearch?.value || "",
      menu: menuSearch?.value || "",
      screen_codes: (screenCode !== 'all' && screenCode) ? screenCode : "",
      action_code: actionCodeSearch?.value || "",
      type: typeSearch || "",
      start_date: start_date
        ? formatDateStringToUTC(
            moment(new Date(start_date))
              .startOf("day")
              .format("Y-MM-DD HH:mm:ss")
          )
        : "",
      end_date: end_date
        ? formatDateStringToUTC(
            moment(new Date(end_date)).endOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      //sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        user_nickname: "",
        user_email: "",
        address: "",
        //breadcrumb: "",
        ip_address: "",
        device_model: "",
        udid_2: "",
        bar_id: "",
        wink_id: "",
        chat_id: "",

        start_date: formatDateStringToUTC(
          moment(new Date()).startOf("day").format("Y-MM-DD HH:mm:ss")
        ),
        end_date: formatDateStringToUTC(
          moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss")
        ),
        user_type: "",
        user_provider: "",
        country_code: "",
        device_os: "",
        app_name: "",
        menu: "",
        screen_codes: "",
        action_code: "",
        ip: "",
        type: "",
        sort_by: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setNicknameSearch((_prev) => "");
    setuser_emailSearch((_prev) => "");
    setAddressSearch((_prev) => "");
    setIPSearch((_prev) => "");
    setDeviceModelSearch((_prev) => "");
    setUUIDSearch((_prev) => "");
    setBarIdSearch((_prev) => "");
    setWinkIdSearch((_prev) => "");
    setChatIdSearch((_prev) => "");

    setIsGuestSearch("");
    setPlatFormSearch((_prev) => null);
    setOSSearch(null);
    setSourceAppSearch((_prev: any) => "");
    setMenuSearch((_prev) => null);
    setIsMultiScreen(false);
    setScreenCodeSearch((_prev: any) => ({
      label: t("All Filter"),
      value: "all",
    }));
    setaction_codeSearch((_prev: any) => null);
    setCountrySearch((_prev: any) => null);
    setDateSearch([
      moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
      moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
    ]);
    setTypeSearch("");
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 50 }}>
              {eventLogs?.meta?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },

      {
        Header: t("App"),
        accessor: "app_name",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const item = cell?.value;
          let imgAppName = getOptionImage(item);

          return (
            item && (
              <div className="d-flex align-items-center whitespace-nowrap">
                {imgAppName ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgAppName ? (
                      <img
                        src={imgAppName}
                        width={20}
                        height={20}
                        alt="user_provider"
                      />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    APP_TYPE_OPTIONS?.find(
                      (item: any) => item?.value === cell?.value
                    )?.label || ""
                  )}
                </div>
              </div>
            )
          );
        },
      },

      /*     {
        Header: t("Menu"),
        accessor: "menu",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              {t(
                LIST_OPTION_MENU?.find(
                  (item: any) => String(item?.value) === String(status)
                )?.label || ""
              )}
            </div>
          );
        },
      }, */

      {
        Header: t("Screen"),
        accessor: "screen_code",
        filterable: false,
        sortable: false,
        thWidth: 160,
        thClass: "text-center",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div style={{ minWidth: 140 }} className="text-center">
              <div
                className="rounded-pill badge"
                style={{ background: "#007BFF" }}
              >
                {t(
                  SCREEN_CONST?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label ||
                    status ||
                    ""
                )}
              </div>
            </div>
          );
        },
      },

      {
        Header: t("Event"),
        accessor: "action_code",
        filterable: false,
        sortable: false,
        thWidth: 240,
        thClass: "text-center",
        Cell: (cell: any) => {
          const screen_code = cell?.row?.original?.screen_code;
          const action_code = cell?.value;
          const EVENT_OPTIONS = SCREEN_CONST?.find(
            (i: any) => i?.value == screen_code
          )?.children;
          return (
            <div style={{ minWidth: 200 }} className="text-center">
              <div
                className="rounded-pill badge"
                style={{ background: "#4DA3FF" }}
              >
                {t(
                  EVENT_OPTIONS?.find(
                    (item: any) => String(item?.value) === String(action_code)
                  )?.label ||
                    action_code ||
                    ""
                )}
              </div>
            </div>
          );
        },
      },

      /* {
        Header: t("Breadcrumb"),
        accessor: "breadcrumb",
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const breadcrumb = cell?.value?.split(",").join(" > ");
          return <div style={{ minWidth: 500 }}>{breadcrumb}</div>;
        },
      }, */

      {
        Header: t("User Type"),
        accessor: "user_type",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_USER_TYPE_LOG[status] || "secondary"
                }`}
              >
                {t(
                  USER_TYPE_LOG_OPTION?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Photo"),
        accessor: "user_avatar",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 80,
        Cell: (cell: any) => (
          <>
            <div className="w-100 text-center " style={{ minWidth: "60px" }}>
              <div
                style={{ width: "45px" }}
                className="m-auto cursor-pointer"
                onClick={() => setLinkImage((prev) => cell?.value ?? avatar1)}
              >
                <img
                  src={cell?.value ?? avatar1}
                  className="rounded-circle avatar-sm"
                  alt="thumbnail"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = avatar1;
                  }}
                />
              </div>
            </div>
          </>
        ),
      },

      {
        Header: t("Nickname"),
        accessor: "user_nickname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("Email"),
        accessor: "user_email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Platform"),
        accessor: "user_provider",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          let user_provider = cell?.row?.original?.user_provider;
          let imgPlatform = getPlatFormImage(user_provider);
          return (
            <div className="d-flex flex-column gap-1">
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgPlatform && (
                    <img
                      src={imgPlatform}
                      width={25}
                      height={25}
                      alt="user_provider"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(
                    capitalizeFirstLetter(
                      user_provider === "default" || user_provider == "guest"
                        ? "Email"
                        : user_provider
                    )
                  )}
                </div>
              </div>
            </div>
          );
        },
      },

      {
        Header: t("deviceOS"),
        accessor: "device_os",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          const deviceOS = cell?.row?.original?.device_os;
          let imgOS = getPlatFormImage(deviceOS);

          return (
            deviceOS && (
              <div
                className="d-flex align-items-center"
                style={{ minWidth: "110px" }}
              >
                {imgOS ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgOS ? (
                      <img src={imgOS} width={20} height={20} alt="platform" />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    LIST_OPTION_OS?.find((item) => item?.value === deviceOS)
                      ?.label ?? ""
                  )}
                </div>
              </div>
            )
          );
        },
      },

      {
        Header: t("Device Id"),
        accessor: "device_id",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 200,
        Cell: (cell: any) => {
          const deviceId = cell?.row?.original?.device_id;
          return (
            deviceId && (
              <CopyWrapper contentCopy={t(`${deviceId}`)} style={{ minWidth: 140 }}>
                {t(`${deviceId}`)}
              </CopyWrapper>
            )
          );
        },
      },
     
      {
        Header: t("Device Model"),
        accessor: "device_model",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          let deviceModel = item?.device_model;
          const os = item?.os;
          if(os === 'ios') {
            deviceModel = deviceModel ? (IPHONE_MODELS[deviceModel as keyof typeof IPHONE_MODELS] ?? deviceModel)  : '';
          }

          return (
            deviceModel && (
              <CopyWrapper contentCopy={t(`${deviceModel}`)} style={{ width: 150 }}>
                {t(`${deviceModel}`)}
              </CopyWrapper>
            )
          );
        },
      },

      {
        Header: t("Manufacturer"),
        accessor: "device_manufacturer",
        filterable: true,
        sortable: false,
        thWidth: 170,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const manufacturer = cell?.row?.original?.device_manufacturer;
          return (
            manufacturer && (
              <div className="cursor-pointer" style={{ minWidth: "160px" }}>
                <CopyWrapper contentCopy={manufacturer}>
                  {`${manufacturer}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("UUID"),
        accessor: "udid",
        filterable: true,
        sortable: false,
        thWidth: 220,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            item?.udid_2 && (
              <div className="cursor-pointer" style={{ minWidth: "200px" }}>
                <CopyWrapper contentCopy={item?.udid_2}>
                  {`${item?.udid_2}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("App Version"),
        accessor: "app_version",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          const row = cell?.row?.original;
          const appVersion = row?.app_build
            ? `${cell?.value} (${row?.app_build})`
            : cell?.value;
          return (
            appVersion && (
              <div className="cursor-pointer" style={{ minWidth: "110px" }}>
                <CopyWrapper contentCopy={appVersion}>
                  {`${appVersion}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("IP"),
        accessor: "id_address",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const ip = cell?.value;
          return (
            ip && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={ip}>{`${ip}`}</CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("Bar ID"),
        accessor: "bar_id",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 180,
        Cell: (cell: any) => {
          const barId = cell?.value;
          return (
            barId && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={barId}>{`${barId}`}</CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("Wink ID"),
        accessor: "wink_id",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 180,
        Cell: (cell: any) => {
          const winkId = cell?.value;
          return (
            winkId && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={winkId}>{`${winkId}`}</CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("Chat ID"),
        accessor: "chat_id",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 180,
        Cell: (cell: any) => {
          const chatId = cell?.value;
          return (
            chatId && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={chatId}>{`${chatId}`}</CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("Location"),
        accessor: "location",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const lat = item?.lat;
          const lng = item?.long;
          const country_code = item?.country_code;

          return lat || lng ? (
            <div className="cursor-pointer" style={{ minWidth: "100px" }}>
              <a
                href={`https://www.google.com/maps/search/${lat},${lng}/@${lat},${lng},17z?entry=ttu`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item?.address || item?.short_address ? (
                  <>{item?.short_address ?? item?.address}</>
                ) : (
                  <span className="d-flex align-items-center gap-1">
                    <i className="ri-map-pin-line"></i> {t("Location")}
                  </span>
                )}
              </a>
            </div>
          ) : (
            <></>
          );
        },
      },
      {
        Header: t("Country"),
        accessor: "country_code",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const countryCode = cell?.row?.original?.country_code;
          const country = countries.find((item) => item?.code === countryCode);

          return (
            countryCode && (
              <div
                className="d-flex flex-column gap-1"
                style={{ minWidth: "130px" }}
              >
                {
                  <div className="cursor-pointer d-flex gap-2 align-items-center ">
                    {country && (
                      <>
                        <img
                          src={country?.flags}
                          width={20}
                          height={20}
                          alt="profile"
                        />
                        <div className="cursor-pointer">
                          {i18n?.language === "ko"
                            ? country?.name_korea
                            : country?.name}
                        </div>
                      </>
                    )}
                  </div>
                }
              </div>
            )
          );
        },
      },

      {
        Header: t("Created at"),
        accessor: "acted_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, eventLogs?.meta?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  const checkHasAllOption = (lstUsers: any) => {
    let allUser = null;
    if (lstUsers instanceof Array) {
      allUser = lstUsers?.find((e: any) => e?.value == "all")
    }

    return allUser;
  }

  const handleSelectedScreenCode = (e: any) => {
    const allToken = checkHasAllOption(e);
    if(allToken) {
      setScreenCodeSearch(allToken)
    }else {
      setScreenCodeSearch(e)
    }
  }

  useEffect(() => {
    document.title = `${t("Event Log")} | ShowStar`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resCountry]: any = await Promise.all([
          countryApi.countries({ page: 1, limit: 20000 }),
        ]);
        setListCountry((_prev: any) => resCountry?.data || []);
      } catch (error: any) {
        return error;
      }
    };

    handleCallAllOption();
  }, []);

  const onCloseImageClick = () => {
    setLinkImage((_prev) => "");
  };

  const screenOptionsLang = SCREEN_CONST.map((i: any) => {
    return { ...i, label: t(i?.label) };
  });

  const allDefaultEvent = [
    ...BAR_SCREEN_CONST,
    ...BAR_REVIEW_SCREEN_CONST,
    ...BAR_DETAIL_SCREEN_CONST,
    ...BAR_MANAGEMENT_SCREEN_CONST,
    ...WINK_SCREEN_CONST,
    ...WINK_COMMENT_SCREEN_CONST,
    ...WINK_DETAIL_SCREEN_CONST,
    ...NEWS_SCREEN_CONST,
    ...CHAT_SCREEN_CONST,
    ...MY_PROFILE_SCREEN_CONST,
    ...OTHER_PROFILE_SCREEN_CONST,
    ...SETTING_SCREEN_CONST,
    ...SCAN_QR_SCREEN,
    ...NOTIFICATION_SCREEN_CONST
  ];

  const uniqueArray = allDefaultEvent.filter(
    (obj, index, self) =>
      index ===
      self.findIndex((o) => o.value === obj.value && o.label === obj.label)
  );

  const [eventOption, setEventOption] = useState<any>([]);

  useEffect(() => {
    const eventByScreen2 = SCREEN_CONST?.filter((i: any) => {
      let data = '';
      if (screenCodeSearch instanceof Array) {
        data = screenCodeSearch?.find((e: any) => e?.value === i?.value)
      } else if(i?.value === screenCodeSearch?.value) {
        data = screenCodeSearch
      }

      return data;
    });
    
    const dataEventOption = eventByScreen2?.length > 0 ? eventByScreen2.flatMap((categories) => categories.children) : uniqueArray;
  
  
    const eventLang = dataEventOption.map((i: any) => {
      return { ...i, label: t(i?.label) };
    });

    setEventOption(eventLang);

  }, [screenCodeSearch, i18n?.language]);

  // const eventByScreen =
  //   SCREEN_CONST?.find((i: any) => i?.value === screenCodeSearch?.value)
  //     ?.children || uniqueArray;

  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Event Log")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={eventLogs?.meta?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Nickname")}`}
                          isShow={!!user_nicknameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Nickname")}...`}
                            value={user_nicknameSearch}
                            onChange={(e) => setNicknameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Email")}`}
                          isShow={!!user_emailSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email")}...`}
                            value={user_emailSearch}
                            onChange={(e) =>
                              setuser_emailSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={`${t("IP")}`} isShow={!!IPSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("IP")}...`}
                            value={IPSearch}
                            onChange={(e) => setIPSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Device Model")}`}
                          isShow={!!deviceModelSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Device Model")}...`}
                            value={deviceModelSearch}
                            onChange={(e) =>
                              setDeviceModelSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("UUID")} isShow={true}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("UUID")}...`}
                            value={uuidSearch}
                            onChange={(e) => setUUIDSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Bar ID")} isShow={true}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Bar ID")}...`}
                            value={barIdSearch}
                            onChange={(e) => setBarIdSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Wink ID")} isShow={true}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Wink ID")}...`}
                            value={winkIdSearch}
                            onChange={(e) => setWinkIdSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Chat ID")} isShow={true}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Chat ID")}...`}
                            value={chatIdSearch}
                            onChange={(e) => setChatIdSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Address")}`}
                          isShow={!!addressSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Address")}...`}
                            value={addressSearch}
                            onChange={(e) => setAddressSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      {/* <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Breadcrumb")}`}
                          isShow={!!breadcrumbSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Breadcrumb")}...`}
                            value={breadcrumbSearch}
                            onChange={(e) =>
                              setBreadcrumbSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>
 */}
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Platform")} isShow={true}>
                          <DropdownPlatform
                            name="user_provider"
                            placeholder={`${t("Platform")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={platFormSearch || null}
                            onChangeSelect={(e: any) => setPlatFormSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("OS")} isShow={true}>
                          <DropdownOptionImage
                            name="device_os"
                            dataList={LIST_OPTION_OS || []}
                            placeholder={`${t("OS")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={oSSearch || ""}
                            onChangeSelect={(e: any) => setOSSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Country")} isShow={true}>
                          <DropdownCountries
                            name="country_code"
                            dataList={listCountry || []}
                            placeholder={`${t("Select Country")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={countrySearch || null}
                            onChangeSelect={(e: any) => setCountrySearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("User Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type-user"
                            dataList={USER_TYPE_LOG_OPTION || []}
                            placeholder={`${t("User Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={isGuestSearch}
                            onChangeSelect={(e: any) =>
                              setIsGuestSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_TYPE_LOG}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("App")} isShow={true}>
                          <DropdownOptionNew
                            name="app_name"
                            dataList={APP_TYPE_OPTIONS || []}
                            placeholder={`${t("Select App Name")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={sourceAppSearch}
                            onChangeSelect={(e: any) => setSourceAppSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            lstImage={true}
                            hideSelectedOptions={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Screen")} isShow={true}>
                          <DropdownOptionMulti 
                            name="screen_code"
                            dataList={screenOptionsLang}
                            placeholder={`${t("Select Screen")}...`}
                            initialValue={screenCodeSearch || null}
                            onChangeSelect={(e: any) => {
                              if(e?.length === 0 || e?.value === 'all') {
                                setIsMultiScreen(false)
                                setScreenCodeSearch({
                                  label: t("All Filter"),
                                  value: "all",
                                })
                              }else {
                                handleSelectedScreenCode(e);
                                setIsMultiScreen(checkHasAllOption(e) ? false : true)
                              }
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "all" }}
                            isMulti={isMultiScreen}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Event")} isShow={true}>
                          <DropdownOption
                            name="action_code"
                            dataList={eventOption}
                            placeholder={`${t("Event")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={actionCodeSearch || null}
                            onChangeSelect={(e: any) => setaction_codeSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!start_date || !!end_date}
                        >
                          <DatePickerCustom
                            startDate={start_date || null}
                            endDate={end_date || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={9}
                        lg={9}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-event-log-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={eventLogs?.list?.length ? eventLogs?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={eventLogs?.meta?.total}
                      customPageCount={Math.ceil(
                        Number(eventLogs?.meta?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isEventLogLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage}
          url={linkImage}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default EventLogNew;
